import React from 'react';
import CeedContactUsHero from '../../components/sections/CeedContactUsHero';
import CeedContactUsForm from '../../components/sections/CeedContactUsForm';

const CeedContactUs = () => {
    
    return(
        <>
      <CeedContactUsHero />
      <CeedContactUsForm />
      </>
    )
}

export default CeedContactUs